import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export interface PageNavTab {
  id: string;
  label: string;
  disabled?: boolean;
}

interface PageNavProps {
  tabs: PageNavTab[];
  activeTab: string;
  onTabChange: (tab: PageNavTab) => void;
}

const PageNav: React.FC<PageNavProps> = ({ tabs, activeTab, onTabChange }) => {
  const activeTabIndex = React.useMemo(() => {
    const index = tabs.findIndex((tab) => tab.id === activeTab);
    return index >= 0 ? index : 0;
  }, [tabs, activeTab]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tab = tabs[newValue];
    if (tab && !tab.disabled) {
      onTabChange(tab);
    }
  };

  // Don't render tabs if there's only one visible tab
  if (tabs.length <= 1) {
    return null;
  }

  return (
    <div className="page-nav">
      <Tabs
        value={activeTabIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        indicatorColor="secondary"
        textColor="inherit"
        className="page-nav__tabs"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.label}
            disabled={tab.disabled}
            className="page-nav__tab"
          />
        ))}
      </Tabs>
    </div>
  );
};

export default PageNav;
